import { updateAccount } from 'modules/accounts/flows';
import {
    actionsColumnType,
    leftPinnedToggleColumn,
    lockedColumn,
    numericColumn,
    rightPinnedColumn,
    staticColumn,
} from 'modules/campaigns/modules/campaigns-reports/config/columns';
import { normalizeColumnDefs } from 'modules/campaigns/modules/campaigns-reports/utils';
import { ToggleSwitchCellRenderer } from '../../../components';
import { AccountListReportActionsCellRenderer } from '../../../components/CellRenderers/AccountList/AccountListReportActionsCellRenderer';
import * as FIELDS from '../../fields';
import { ACCOUNT_LIST_REPORT_ID } from './accountListReportId';

const accountListReportColumnDefinitions = [
    {
        headerName: FIELDS.IS_ACTIVE.label,
        field: FIELDS.IS_ACTIVE.field,
        type: [leftPinnedToggleColumn, staticColumn, lockedColumn],
        cellRenderer: ToggleSwitchCellRenderer,
        csv: false,
        valueChangeHandler: ({ isActive }, rowData, _, __, ___, context) =>
            updateAccount({
                accountId: rowData?.accountId,
                accountName: rowData?.accountName,
                isActive,
                adminNetworkAccountId: context.accountName,
            }),
        minWidth: 60,
        width: 60,
        maxWidth: 60,
    },
    {
        headerName: FIELDS.ACCOUNT_ID.label,
        field: FIELDS.ACCOUNT_ID.field,
        type: [numericColumn],
        sortable: false,
    },
    {
        headerName: FIELDS.ACCOUNT_NAME_ID.label,
        field: FIELDS.ACCOUNT_NAME_ID.field,
        sortable: false,
    },
    {
        headerName: FIELDS.ACCOUNT_DESCRIPTION.label,
        field: FIELDS.ACCOUNT_DESCRIPTION.field,
        sortable: false,
    },
    {
        headerName: FIELDS.ACCOUNT_TYPE.label,
        field: FIELDS.ACCOUNT_TYPE.field,
        sortable: false,
    },
    {
        headerName: FIELDS.CURRENCY.label,
        field: FIELDS.CURRENCY.field,
        sortable: false,
    },
    {
        headerName: FIELDS.TIME_ZONE_NAME.label,
        field: FIELDS.TIME_ZONE_NAME.field,
        sortable: false,
    },
    {
        headerName: FIELDS.ACCOUNT_LANGUAGE.label,
        field: FIELDS.ACCOUNT_LANGUAGE.field,
        sortable: false,
    },
    {
        headerName: FIELDS.ACCOUNT_COUNTRY.label,
        field: FIELDS.ACCOUNT_COUNTRY.field,
        sortable: false,
    },
    {
        headerName: FIELDS.ACTIONS_COLUMN.label,
        field: FIELDS.ACTIONS_COLUMN.field,
        valueGetter: params => params.data,
        type: [rightPinnedColumn, actionsColumnType, staticColumn],
        cellRenderer: AccountListReportActionsCellRenderer,
        csv: false,
        minWidth: 50,
        width: 50,
    },
];

export const columnDefinitions = normalizeColumnDefs(accountListReportColumnDefinitions, ACCOUNT_LIST_REPORT_ID);
